import React, { FC, Fragment, useState } from 'react';
import { NetworkStatus, useQuery } from '@apollo/client';
import Loader from 'components/shared/loader/loader.component';
import MissedTransportOrdersPageActions from 'components/transport-admin/missed-transport-orders-page-actions/missed-transport-orders-page-actions.component';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import TransportOrderList from 'components/transport-admin/transport-order-list/transport-order-list.component';
import { TransportOrder, TransportOrderFilter } from 'models/transport';
import { transportsTemplate } from 'apollo/templates/transport';

const MissedTransportOrders: FC = () => {
    const [lastOffset, setLastOffset] = useState(0);
    const [transportOrders, setTransportOrders] = useState<TransportOrder[]>([]);
    const [transportFilters, setTransportFilters] = useState<TransportOrderFilter>({
        date: new Date(),
        hasProblem: true,
    });
    const { showBoundary } = useDenthubErrorBoundary();
    const { loading, fetchMore, networkStatus } = useQuery(transportsTemplate, {
        notifyOnNetworkStatusChange: true,
        variables: { limit: 20, offset: 0, filters: transportFilters },
        onCompleted: ({ transports }) => {
            setTransportOrders(transports);
            setLastOffset(transports.length);
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const handleFilterChange = (filters: TransportOrderFilter) => {
        filters.hasProblem = true;
        setTransportFilters(filters);
        setLastOffset(0);
    };

    const handleFetchMore = () => {
        if (fetchMore) {
            fetchMore({
                variables: {
                    offset: lastOffset,
                    filters: transportFilters,
                },
            });
        }
    };

    const resolveTransportProblemFlag = (transportId: string) => {
        const transports = JSON.parse(JSON.stringify(transportOrders));
        const index = transports.findIndex((transport: TransportOrder) => transport._id === transportId);
        if (index !== -1) {
            transports.splice(index, 1);
            setTransportOrders(transports);
        }
    };

    const updateTransport = (transport: TransportOrder) => {
        const transports = JSON.parse(JSON.stringify(transportOrders));
        const index = transports.findIndex((trans: TransportOrder) => trans._id === transport._id);
        if (index !== -1) {
            transports.splice(index, 1, transport);
            setTransportOrders(transports);
        }
    };

    return (
        <Fragment>
            <MissedTransportOrdersPageActions onFilterChange={handleFilterChange} />
            {loading && networkStatus !== NetworkStatus.fetchMore ? (
                <Loader />
            ) : (
                <TransportOrderList
                    transportOrders={transportOrders}
                    onFetchMore={handleFetchMore}
                    resolveTransportProblemFlag={resolveTransportProblemFlag}
                    onUpdateTransport={updateTransport}
                />
            )}
        </Fragment>
    );
};

export default MissedTransportOrders;
